export default __webpack_public_path__ + "static/media/DeniedAccessIcon.a3c9c446.svg";